import { ChartFormat } from './viz-format.types';
import { ModeField } from '../flamingo.types';
import type * as Highcharts from 'highcharts';

export enum SeriesType {
  LINE = 'LINE',
  BUBBLE = 'BUBBLE',
  NAMED_POINT = 'NAMED_POINT',
  PAIRED_POINT = 'PAIRED_POINT',
}

export interface NamedPoint {
  readonly name?: any;
  readonly y: any;
  readonly x?: any;
  readonly z?: any;
}

export interface NamedPointSeries {
  readonly name: any;
  readonly data: NamedPoint[];
  readonly colorByPoint?: boolean;
}

export interface NamedPointData {
  readonly series: NamedPointSeries[];
  readonly seriesType: typeof SeriesType.NAMED_POINT;
}

export type PairedPoint = [any, any];

export interface PairedPointSeries {
  readonly x?: any;
  readonly name: any;
  readonly data: PairedPoint[];
  readonly innerSize?: string;
}

export interface PairedPointData {
  readonly categories: any[];
  readonly series: PairedPointSeries[];
  readonly seriesType: typeof SeriesType.PAIRED_POINT;
}

export interface LineSeries {
  readonly name: any;
  readonly data: any[];

  readonly type?: string;
  readonly yAxis?: number;
  readonly color?: string;
  readonly dataLabels?: Highcharts.DataLabelsOptions;
}

export interface LineData {
  readonly name?: any;
  readonly categories?: any[];
  readonly series: LineSeries[];
  readonly seriesType: typeof SeriesType.LINE;
}

export interface BubbleSeries {
  readonly name: any;
  readonly data: NamedPoint[];
}

export interface BubbleData {
  readonly categories?: any[];
  readonly series: BubbleSeries[];
  readonly seriesType: typeof SeriesType.BUBBLE;
}

export type PointData = NamedPointData | PairedPointData;

export type ChartData = LineData | BubbleData | NamedPointData | PairedPointData;

export type LineDataTransform = (chartData: LineData, chartFormat: ChartFormat) => LineData;

export type BubbleDataTransform = (chartData: BubbleData, chartFormat: ChartFormat) => BubbleData;

export type PointDataTransform = (chartData: PointData, chartFormat: ChartFormat) => PointData;

export type NamedPointDataTransform = (chartData: NamedPointData, chartFormat: ChartFormat) => NamedPointData;

export type PairedPointDataTransform = (chartData: PairedPointData, chartFormat: ChartFormat) => PairedPointData;

export interface SeriesField {
  name: string;
  type: string;
  yAxis: number;
  yField: ModeField;
  groupField: ModeField | undefined;
}
